import Vue from 'ninenine-white-label/Vue'
import Vuex from 'vuex'

import opportunities from 'ninenine-white-label/store/modules/opportunities'
import location from 'ninenine-white-label/store/modules/location'
import user from 'ninenine-white-label/store/modules/user'
import domains from 'ninenine-white-label/store/modules/domains'
import graphql_queries from 'ninenine-white-label/store/modules/graphql_queries'
import tests from 'ninenine-white-label/store/modules/tests'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    opportunities,
    location,
    user,
    domains,
    graphql_queries,
    tests
  },

  state: {
    source: 'carreiras',
    companyId: process.env.VUE_APP_COMPANY_ID,

    bancoDeTalentos: process.env.VUE_APP_BANCO_DE_TALENTOS,

    tkn: `Token token=${process.env.VUE_APP_API_TOKEN}`,

    deviseForm: null,
    deviseLoading: false,

    deviseTrying: { },

    deviseClosedToReadTerms: { },
    pendingAcceptTerms: false,

    personalDataForm: { },
    educationsForms: [],
    professionalExperiencesForms: [],
    languagesForms: [],
    flag_no_professional_experience: false,
    opportunityQuestionsForm: { },
    indicationForm: { },

    companyName: 'Grupo Boticário',

    websiteName: 'Grupo Boticário Carreiras',

    areas: [
    ],

    teams: [
    ],

    faq: {
      "slug": "faq",
      "title": "Faq",
      "faqItems": [
        {
          "title": "Por que me inscrever no Trainee do Grupo Boticário?",
          "content": `<p>É uma oportunidade imperdível para acelerar sua carreira em uma das empresas mais inovadoras do mundo e do setor de beleza! No nosso programa, você terá a chance de se desenvolver profissionalmente, participar de projetos desafiadores e ser parte de uma equipe que valoriza a criatividade e a diversidade. Aqui, você poderá colocar em prática todo o seu potencial e contribuir para o nosso compromisso com a sustentabilidade e a responsabilidade social.</p>`,
        },
        {
          "title": "Como eu me inscrevo?",
          "content": `<p>Para se inscrever, é simples: basta clicar no botão "Inscreva-se" no canto superior direito deste site e seguir todos os passos até concluir sua inscrição. Lembre-se de preencher todas as informações necessárias e revisar seu cadastro antes de enviar!</p>`,
        },
        {
          "title": "Quem pode se inscrever?",
          "content": `<p>Você deve estar graduando entre janeiro de 2020 e dezembro de 2024. Aceitamos estudantes de diversas áreas de formação. Um segundo idioma não é obrigatório.</p>`,
        },
        {
          "title": "Como receberei a comunicação?",
          "content": `<p>Todas as comunicações sobre o processo seletivo e outras informações importantes serão feitas via e-mail. Portanto, certifique-se de fornecer um e-mail válido e acompanhar sua caixa de entrada!</p>`,
        },
        {
          "title": "Caso eu tenha alguma dúvida, como posso entrar em contato?",
          "content": `<p>Envie suas perguntas para nosso e-mail: <a href="mailto:traineegrupoboticario@99jobs.com">traineegrupoboticario@99jobs.com</a>. Nossa equipe responderá o mais breve possível.</p>`,
        },
        
      ]
    }
  },

  getters: {
    basicProfileEmpty: state => {
      const profile = state.user.profile;

      return (
        !profile.nationality || profile.nationality.length == 0 ||
        (
          (!profile.cpf || profile.cpf.length == 0) &&
          (!profile.passport || profile.passport.length == 0)
        ) ||
        !profile.phone || profile.phone.length == 0 ||
        !profile.birthday || profile.birthday.length == 0 ||
        !profile.gender || profile.gender.length == 0 ||
        !profile.raceAndEthnicity || profile.raceAndEthnicity.length == 0 ||
        !profile.pronoun || profile.pronoun.length == 0 ||
        !profile.personalIncome || profile.personalIncome.length == 0 ||
        !profile.location.zipcode || profile.location.zipcode.length == 0 ||
        !profile.location.street || profile.location.street.length == 0 ||
        !profile.location.number || profile.location.number.length == 0 ||
        !profile.location.neighborhood || profile.location.neighborhood.length == 0 ||
        !profile.location.city || profile.location.city.length == 0 ||
        !profile.location.stateId || profile.location.stateId.toString().length == 0
      ) &&
        (!profile.educations || profile.educations.length == 0) &&
        (!profile.professionalExperiences || profile.professionalExperiences.length == 0 || state.flag_no_professional_experience == false)
    }
  },


  mutations: {
    CHANGE_TKN(state, payload){
      state.tkn = payload;
    },

    DEVISE_FORM(state, payload) {
      state.deviseForm = payload;
    },

    DEVISE_LOADING(state, payload) {
      state.deviseLoading = payload;
    },

    DEVISE_TRYING(state, payload) {
      state.deviseTrying = payload == null ? { } : payload;
    },

    DEVISE_DEVISE_CLOSED_TO_READ_TERMS(state, payload) {
      state.deviseClosedToReadTerms = payload == null ? { } : payload;
    },

    SET_PENDING_ACCEPT_TERMS(state, payload) {
      state.pendingAcceptTerms = payload;
    },

    PERSONAL_DATA_FORM(state, payload) {
      state.personalDataForm = payload;
    },

    EDUCATIONS_FORMS(state, payload) {
      if (!payload) {
        state.educationsForms = []
      } else {
        if (state.educationsForms.find(form => form._uid == payload._uid)) {
          state.educationsForms[state.educationsForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.educationsForms.push(payload);
        }
      }
    },

    PROFESSIONAL_EXPERIENCES_FORMS(state, payload) {
      if (!payload) {
        state.professionalExperiencesForms = []
      } else {
        if (state.professionalExperiencesForms.find(form => form._uid == payload._uid)) {
          state.professionalExperiencesForms[state.professionalExperiencesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.professionalExperiencesForms.push(payload);
        }
      }
    },

    LANGUAGES_FORMS(state, payload) {
      if (!payload) {
        state.languagesForms = []
      } else {
        if (state.languagesForms.find(form => form._uid == payload._uid)) {
          state.languagesForms[state.languagesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.languagesForms.push(payload);
        }
      }
    },

    SET_FLAG_PROFESSIONAL_EXPERIENCE(state, payload) {
      state.flag_no_professional_experience = payload
    },

    OPPORTUNITY_QUESTIONS_FORM(state, payload) {
      state.opportunityQuestionsForm = payload
      localStorage.setItem('opportunity_questions', JSON.stringify(payload))
    },

    INDICATION_FORM(state, payload) {
      state.indicationForm = payload
      localStorage.setItem('indication_form', JSON.stringify(payload))
    }
  },

  actions: {
  }
})
